import React from 'react';
import { Link } from "react-router-dom";

interface SafeLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  forceFullReload?: boolean;
  [key: string]: any;
}

export const SafeLink: React.FC<SafeLinkProps> = ({
  to,
  children,
  className,
  target,
  forceFullReload,
  ...props
}) => {
  // Use <Link> for internal routes if no forceFullReload and no target="_blank"
  const isInternal =
    typeof to === "string" &&
    to.startsWith("/") &&
    !forceFullReload &&
    !target;

  if (isInternal) {
    return (
      <Link to={to} className={className} {...props}>
        {children}
      </Link>
    );
  }

  // Otherwise, fallback to <a>
  return (
    <a
      href={to}
      className={className}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      {...props}
    >
      {children}
    </a>
  );
};